import { Space, Table } from "antd";
import React from "react";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function DataTaskTable(props: any) {
  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "TaskName",
      title: "Task Name",
    },
    {
      dataIndex: "descriptions",
      title: "Description",
    },
    {
      dataIndex: "status",
      title: "Status",
    },
    {
      dataIndex: "hourss",
      title: "hours",
    },
    {
      dataIndex: "minituess",
      title: "minitues",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/HR/task_view/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={Array.isArray(props?.dataSource) ? props.dataSource : []} // Safe fallback
        pagination={props?.pagination}
        rowKey={(record: any) => record.id}
      />
    </div>
  );
}

export default DataTaskTable;
